import { Icon, Modal, ModalActions, ModalContent, ModalHeader } from '@msi/cobalt-react';
import React, { useState, useCallback } from 'react';
import './AddAreaModal.css'; 

interface AddAreaProps {
    modalHeaderLabel: string;
    value: string;
    addButtonEnabled: boolean;
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleSubmit: () => void;
    handleClose: () => void;
}

const AddAreaModal: React.FC<AddAreaProps> = ({
    modalHeaderLabel,
    value,
    addButtonEnabled,
    handleChange,
    handleSubmit,
    handleClose
}) => {
    const [show, setShow] = useState(false);

    const onClick = useCallback(() => setShow(true), [setShow]);
    const onClose = useCallback(() => {
        setShow(false);
        handleClose();
    }, [setShow, handleClose]);

    const onSave = useCallback(() => {
        setShow(false);
        handleSubmit();
    }, [setShow, handleSubmit]);

    return (
        <div className="d-flex items-center ">
            <button
                type="button"
                className="btn btn-outline-primary border-0 add-new-button d-flex align-items-center"
                disabled={!addButtonEnabled}
                onClick={onClick}
            >
                <Icon
                    name="ic_add"
                    size={19}
                    color="#007bff"
                    className="msi-icon"
                /> 
                <span>Add New</span>
            </button>
            <Modal handleCloseModal={onClose} showModal={show}>
            <ModalHeader>{modalHeaderLabel}</ModalHeader>
            <ModalContent>
                <input
                    type="text"
                    id="newArea"
                    className="msi-input"
                    value={value}
                    onChange={handleChange}
                    required
                />
            </ModalContent>
            <ModalActions>
                <button
                    type="button"
                    className="msi-btn msi-btn-secondary"
                    onClick={onClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="msi-btn"
                    onClick={onSave}
                    disabled={!value.trim()}
                >
                    Save
                </button>
            </ModalActions>
            </Modal>
        </div>
    );
};

export default AddAreaModal;